import React from 'react';
import { makeStyles, withStyles } from '@mui/styles';
import MuiDialogTitle from '@mui/material/DialogTitle';
import {
  Typography,
  DialogActions,
  DialogContent,
  IconButton,
  Dialog,
  Grid,
} from '@mui/material';
import { LoadingPage, Icons } from 'components';
import { createSanitizeHtml } from 'utility';
import clsx from 'clsx';
const SimpleDialog = ({
  open,
  onClose,
  title = '',
  content = '',
  icon = null,
  loading,
  children,
  actions,
  formSubmit = null,
  customClass = {},
  hideClose = false,
  ...rest
}) => {
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={!hideClose ? onClose : null}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className={classes.root}
      {...rest}
    >
      <DialogTitle icon={icon} onClose={!hideClose ? onClose : null}>
        {title}
      </DialogTitle>
      {formSubmit ? (
        <form onSubmit={formSubmit} autoComplete="off" noValidate>
          <DialogContent className={clsx(classes.content, customClass)}>
            {loading ? (
              <LoadingPage />
            ) : (
              <>
                {content && (
                  <div dangerouslySetInnerHTML={{ __html: createSanitizeHtml(content) }} />
                )}
                {children}
              </>
            )}
          </DialogContent>

          <DialogActions className={classes.actions}>{actions}</DialogActions>
        </form>
      ) : (
        <>
          <DialogContent className={clsx(classes.content, customClass)}>
            {loading ? (
              <LoadingPage />
            ) : (
              <>
                {content && (
                  <div dangerouslySetInnerHTML={{ __html: createSanitizeHtml(content) }} />
                )}
                {children}
              </>
            )}
          </DialogContent>
          {actions && !loading && (
            <DialogActions className={classes.actions}>{actions}</DialogActions>
          )}
        </>
      )}
    </Dialog>
  );
};

const useStyles = makeStyles((theme) => {
  return {
    root: {
      maxWidth: '95%',
      '& .MuiDialog-paper': {
        borderRadius: '10px',
        overflowY: 'inherit',
      },
      '& .MuiDialogContent-root': {
        overflowY: 'auto',
        '&::scrollbar-track': {
          width: '0',
          minWidth: '0',
        },
        '&::-moz-scrollbar-track': {
          width: '0',
          minWidth: '0',
        },
        '&::-webkit-scrollbar-track': {
          width: '0',
          minWidth: '0',
        },
        '&::-webkit-scrollbar': {
          width: '0',
          minWidth: '0',
        },
        '&::-webkit-scrollbar-thumb': {
          width: '0',
          minWidth: '0',
        },
        '&.noneOverFlow': {
          overflowY: 'inherit',
        },
      },
      '& .MuiDialogActions-root': {
        justifyContent: 'flex-start',
        marginTop: theme.spacing(1),
        marginInlineStart: theme.spacing(1),
        paddingBottom: theme.spacing(2),
      },
      '& .MuiDialog-container': {
        width: '100vw',
        [theme.breakpoints.down('sm')]: {
          width: '100%',
          justifyContent: 'space-around',
        },
      },
    },
    content: {
      minWidth: 444,
      padding: '25px',
      // MUI removes the top padding from DialogContent when it follows DialogTitle.
      // Keep the shared dialog spacing consistent for both text and form content.
      paddingTop: '20px !important',
      [theme.breakpoints.down('sm')]: {
        minWidth: 'auto',
        padding: '12px 20px',
        paddingTop: '12px !important',
      },
    },
    actions: {
      display: 'flex',
      flexDirection: 'row-reverse',
      gap: '15px',
      padding: '20px 20px 22px',
    },
  };
});

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: '20px',
    borderBottom: '1px solid #E2E5E9',
    '& .MuiGrid-container': {
      alignItems: 'center',
    },
        '& .MuiDialogContent-root':{
      width: '100%',
    },
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(0.5),
    top: theme.spacing(0.5),
    color: theme.palette.grey[500],
  },
 
  icon: {
    padding: 0,
    height: 23,
    '& > *': {
      padding: 0,
      marginInlineEnd: 10,
      fontSize: 23,
    },
  },
  title: {
    marginTop: 2,
    fontSize: 16,
    color: '#0C0E10',
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, icon, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Grid container direction="row" alingitems="center">
        <div className={classes.icon}>{icon ?? <Icons icon='Info' color='#2b3990' size='22' />}</div>
        <Typography variant="h6" className={classes.title}>
          {children}
        </Typography>
      </Grid>

      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
          size="large">
          <Icons icon='Close' color='#939393' size='20' />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

export default SimpleDialog;
